import styled from 'styled-components';

export const TopPageWrapper = styled.div`
  width: fit-content;
  display: flex;
`;
